export const fmt = (val, decimals = 2) => {
  if (val === null || val === undefined || val === "") return "-";
  return new Intl.NumberFormat("tr-TR", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(val);
};

export const fmtCurrency = (val, currency = "₺") => {
  if (val === null || val === undefined || val === "") return "-";
  return `${fmt(val)} ${currency}`;
};

export const fmtDate = (dateStr) => {
  if (!dateStr) return "-";
  try {
    return new Date(dateStr).toLocaleDateString("tr-TR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  } catch {
    return dateStr;
  }
};

export const fmtDateTime = (dateStr) => {
  if (!dateStr) return "-";
  try {
    return new Date(dateStr).toLocaleString("tr-TR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return dateStr;
  }
};

export const BRAND_COLORS = {
  audi: "bg-red-50 text-red-600 border-red-200",
  vw: "bg-blue-50 text-blue-700 border-blue-200",
  seat: "bg-orange-50 text-red-700 border-orange-200",
  skoda: "bg-green-50 text-green-800 border-green-200",
  porsche: "bg-yellow-50 text-yellow-700 border-yellow-200",
  diger: "bg-slate-100 text-slate-600 border-slate-200",
};

const BRAND_LOGOS = [
  { match: ["4U"], src: "/brand-logos/4u.jpg" },
  { match: ["ABA"], src: "/brand-logos/aba-v2.png" },
  { match: ["AJUSA"], src: "/brand-logos/ajusa.png" },
  { match: ["AMC"], src: "/brand-logos/amc.png" },
  { match: ["ART"], src: "/brand-logos/art-v2.png" },
  { match: ["HENKEL"], src: "/brand-logos/henkel.jpg" },
  { match: ["ATE"], src: "/brand-logos/ate.jpg" },
  { match: ["AYD"], src: "/brand-logos/ayd.jpg" },
  { match: ["BLUE PRINT"], src: "/brand-logos/blue-print-v2.png" },
  { match: ["BREMBO"], src: "/brand-logos/brembo.jpg" },
  { match: ["DOGRU KAUCUK"], src: "/brand-logos/dogru-kaucuk.jpg" },
  { match: ["FAG"], src: "/brand-logos/fag.jpg" },
  { match: ["FEBI"], src: "/brand-logos/febi.jpg" },
  { match: ["GKN"], src: "/brand-logos/gkn.jpg" },
  { match: ["LECOY"], src: "/brand-logos/lecoy.jpg" },
  { match: ["LEMFORDER"], src: "/brand-logos/lemforder.png" },
  { match: ["MAGNETTI MARELLI"], src: "/brand-logos/magnetti-marelli.jpg" },
  { match: ["MEYLE"], src: "/brand-logos/meyle-v2.jfif" },
  { match: ["MOTOCAR"], src: "/brand-logos/motocar-v2.png" },
  { match: ["OPTIMAL"], src: "/brand-logos/optimal.jpg" },
  { match: ["PURFLUX"], src: "/brand-logos/purflux.jpg" },
  { match: ["RAPRO"], src: "/brand-logos/rapro.jpg" },
  { match: ["TEKNOROT"], src: "/brand-logos/teknorot.jpg" },
  { match: ["VIEMAX"], src: "/brand-logos/viemax.jpg" },
  { match: ["VW", "VOLKSWAGEN", "VW ORIJINAL", "VW ORIGINAL"], slug: "volkswagen", color: "001E50" },
  { match: ["AUDI"], slug: "audi", color: "BB0A30" },
  { match: ["SEAT"], slug: "seat", color: "33302E" },
  { match: ["CUPRA"], slug: "cupra", color: "946B2D" },
  { match: ["SKODA"], slug: "skoda", color: "0E3A2F" },
  { match: ["PORSCHE", "PORSCHE ORIJINAL", "PORSCHE ORIGINAL"], slug: "porsche", color: "B12B28" },
];

const LOCAL_BRAND_LOGOS = {
  "AFTERMARKET": "/brand-logos/aftermarket.png",
  "ASAHI": "/brand-logos/asahi.png",
  "BENTLEY GENUINE": "/brand-logos/bentley-v2.jfif",
  "CAVO": "/brand-logos/cavo.png",
  "CIFAM": "/brand-logos/cifam.png",
  "DAYCO": "/brand-logos/dayco-v2.png",
  "DOCTOR": "/brand-logos/doctor.png",
  "DOTPARTS": "/brand-logos/dotparts.jpg",
  "EUROSTAMP": "/brand-logos/eurostamp.png",
  "FACET": "/brand-logos/facet.png",
  "FAE": "/brand-logos/fae.png",
  "FTE": "/brand-logos/fte.png",
  "GARRETT": "/brand-logos/garrett-v2.png",
  "GEMO": "/brand-logos/gemo-v2.png",
  "GEMSAFT": "/brand-logos/gemsaft.jfif",
  "GLYCO": "/brand-logos/glyco-v2.png",
  "GOMET": "/brand-logos/gomet.png",
  "GRAF": "/brand-logos/graf.png",
  "GOETZE": "/brand-logos/goetze.png",
  "HATTAT": "/brand-logos/hattat.png",
  "HEPU": "/brand-logos/hepu.png",
  "HUCO": "/brand-logos/huco.png",
  "IBRAS/NIFEA": "/brand-logos/ibras.png",
  "ISAM": "/brand-logos/isam.jfif",
  "ITSA": "/brand-logos/itsa.png",
  "IWIS": "/brand-logos/iwis.png",
  "KING": "/brand-logos/king.png",
  "MAPA": "/brand-logos/mapa.png",
  "MEAT&DORIA": "/brand-logos/meat-doria.jfif",
  "METELLI": "/brand-logos/metelli-v2.png",
  "MITSUBISHI TURBO": "/brand-logos/mitsubishi-turbo.jfif",
  "ORAN": "/brand-logos/oran.png",
  "OSSCA": "/brand-logos/ossca.jfif",
  "PHILIPS": "/brand-logos/philips-v2.png",
  "POLIPLAST": "/brand-logos/poliplast.png",
  "PORSCHE": "/brand-logos/porsche-v2.png",
  "PORSCHE ORIJINAL": "/brand-logos/porsche-v2.png",
  "PORSCHE ORIGINAL": "/brand-logos/porsche-v2.png",
  "PRASCO": "/brand-logos/prasco.jfif",
  "REINZ": "/brand-logos/reinz-v2.png",
  "REMSA": "/brand-logos/remsa.png",
  "ROADHOUSE": "/brand-logos/roadhouse.jfif",
  "RUVILLE": "/brand-logos/ruville-v2.jfif",
  "SAMKO": "/brand-logos/samko.jfif",
  "SCHAEFFLER CHINA": "/brand-logos/schaeffler-china.jfif",
  "SNR": "/brand-logos/snr.png",
  "STABILUS": "/brand-logos/stabilus-v2.png",
  "SUPAR": "/brand-logos/supar-v2.png",
  "SUPSAN": "/brand-logos/supsan.jfif",
  "TETIK": "/brand-logos/tetik-v2.png",
  "TRUCKTECH": "/brand-logos/trucktech.png",
  "TUNCH": "/brand-logos/tunch.png",
  "UCPA": "/brand-logos/ucpa.png",
  "UFI": "/brand-logos/ufi.png",
  "VAGENPAR": "/brand-logos/vagenpar.jpg",
  "VARTA": "/brand-logos/varta-v2.png",
  "VEKA": "/brand-logos/veka.png",
  "VIKA PARTS": "/brand-logos/vika.png",
  "VISTEON": "/brand-logos/visteon.png",
  "WABCO": "/brand-logos/wabco-v2.png",
  "WAHLER": "/brand-logos/wahler.png",
  "ZIMMERMANN": "/brand-logos/zimmermann-v3.png",
  "MANN-FILTER": "/brand-logos/mann-filter-v2.png",
  "BERU (BORGWARNER)": "/brand-logos/beru.jpg",
  "BILSTEIN": "/brand-logos/bilstein.png",
  "BMY": "/brand-logos/bmy-v2.png",
  "BOGE": "/brand-logos/boge-v2.png",
  "BORGWARNER": "/brand-logos/borgwarner-v3.png",
  "BORSEHUNG": "/brand-logos/borsehung.png",
  "BOSCH": "/brand-logos/bosch.png",
  "BREMI": "/brand-logos/bremi.jfif",
  "BSG": "/brand-logos/bsg.jfif",
  "CASTROL": "/brand-logos/castrol-v2.png",
  "CONTITECH": "/brand-logos/contitech.png",
  "CORTECO": "/brand-logos/corteco.jpg",
  "DELPHI": "/brand-logos/delphi.png",
  "DENSO": "/brand-logos/denso.png",
  "DEPO": "/brand-logos/depo-v2.png",
  "DPA": "/brand-logos/dpa.jfif",
  "ELRING": "/brand-logos/elring.jpg",
  "ESTAS": "/brand-logos/estas.png",
  "FERODO": "/brand-logos/ferodo-v2.png",
  "FILTRON": "/brand-logos/filtron.jpg",
  "GATES": "/brand-logos/gates.jpg",
  "GEBA": "/brand-logos/geba.png",
  "GK": "/brand-logos/gk.jfif",
  "GSP": "/brand-logos/gsp.png",
  "GUNES": "/brand-logos/gunes.png",
  "HELLA": "/brand-logos/hella-v2.jfif",
  "HELLA PAGID": "/brand-logos/hella-pagid.png",
  "HENGST": "/brand-logos/hengst.jpg",
  "HERT+BUSS": "/brand-logos/hert-buss.jpg",
  "HITACHI/ASTEMO": "/brand-logos/hitachi-astemo.png",
  "INA": "/brand-logos/ina-v2.png",
  "KALE": "/brand-logos/kale.png",
  "KAUTEK": "/brand-logos/kautek.png",
  "KKK (BORGWARNER)": "/brand-logos/kkk-borgwarner.png",
  "KOLBENSCHMIDT": "/brand-logos/kolbenschmidt-v3.png",
  "KYB": "/brand-logos/kyb.jpg",
  "LESJOFORS": "/brand-logos/lesjofors.png",
  "LIQUI MOLY": "/brand-logos/liqui-moly.png",
  "LPR BRAKES": "/brand-logos/lpr-brakes.jfif",
  "LUK": "/brand-logos/luk-v2.png",
  "MAHLE": "/brand-logos/mahle.jpg",
  "MANN-FILTER": "/brand-logos/mann-filter-v2.png",
  "MAYSAN MANDO": "/brand-logos/maysan-mando.jpg",
  "MONROE": "/brand-logos/monroe.jpg",
  "NGK/NTK": "/brand-logos/ngk-ntk.jfif",
  "NISSENS": "/brand-logos/nissens.jpg",
  "NRF": "/brand-logos/nrf.png",
  "NURAL": "/brand-logos/nural.png",
  "PHIRA": "/brand-logos/phira-v2.png",
  "PIERBURG": "/brand-logos/pierburg.png",
  "SACHS": "/brand-logos/sachs.jpg",
  "SILBAK": "/brand-logos/silbak.png",
  "SKF": "/brand-logos/skf-v2.png",
  "SPIDAN": "/brand-logos/spidan.jfif",
  "SPOT ORIJINAL": "/brand-logos/spot-orijinal.png",
  "SWAG": "/brand-logos/swag.png",
  "SWF": "/brand-logos/swf.png",
  "TEXTAR": "/brand-logos/textar-v2.png",
  "TOPRAN": "/brand-logos/topran.jfif",
  "TRW": "/brand-logos/trw.jpg",
  "TYC": "/brand-logos/tyc.png",
  "ULO": "/brand-logos/ulo.png",
  "VALEO": "/brand-logos/valeo.jpg",
  "VDO": "/brand-logos/vdo.png",
  "VITESCO": "/brand-logos/vitesco.png",
  "YTT": "/brand-logos/ytt.png",
};

export const normalizeBrand = (brand) => (brand || "")
  .trim()
  .toLocaleUpperCase("tr-TR")
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "")
  .replace(/İ/g, "I");

export const brandInitials = (brand) => {
  const words = normalizeBrand(brand).split(/[^A-Z0-9]+/).filter(Boolean);
  return (words.slice(0, 2).map((word) => word[0]).join("") || "?").slice(0, 2);
};

export const BRAND_LOGO_OPTIONS = Array.from(new Set([
  ...BRAND_LOGOS.flatMap(({ match }) => match),
  ...Object.keys(LOCAL_BRAND_LOGOS),
])).sort((a, b) => a.localeCompare(b, "tr"));

export const hasStaticBrandLogo = (brand) => {
  const normalized = normalizeBrand(brand);
  return Boolean(LOCAL_BRAND_LOGOS[normalized] || BRAND_LOGOS.some(({ match }) => match.includes(normalized)));
};

export const getStaticBrandLogoSrc = (brand) => {
  const normalized = normalizeBrand(brand);
  const logo = BRAND_LOGOS.find(({ match }) => match.includes(normalized));
  return LOCAL_BRAND_LOGOS[normalized] || logo?.src || (logo ? `https://cdn.simpleicons.org/${logo.slug}/${logo.color}` : "");
};

export const BrandBadge = ({ brand }) => {
  const key = (brand || "diger").toLowerCase();
  const colors = BRAND_COLORS[key] || BRAND_COLORS.diger;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold uppercase tracking-wider border ${colors}`}>
      {brand || "Diğer"}
    </span>
  );
};

export const STATUS_CONFIG = {
  beklemede: { label: "Beklemede", color: "bg-amber-100 text-amber-700 border-amber-200" },
  onaylandi: { label: "Onaylandı", color: "bg-blue-100 text-blue-700 border-blue-200" },
  hazirlaniyor: { label: "Onaylandı", color: "bg-blue-100 text-blue-700 border-blue-200" },
  sevkiyat: { label: "Onaylandı", color: "bg-blue-100 text-blue-700 border-blue-200" },
  tamamlandi: { label: "Tamamlandı", color: "bg-green-100 text-green-700 border-green-200" },
  iptal: { label: "İptal", color: "bg-red-100 text-red-600 border-red-200" },
};

export const StatusBadge = ({ status }) => {
  const cfg = STATUS_CONFIG[status] || { label: status, color: "bg-slate-100 text-slate-600 border-slate-200" };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold border ${cfg.color}`}>
      {cfg.label}
    </span>
  );
};

export const ROLE_LABELS = {
  admin: "Admin",
  satis_destek: "Satış Destek",
  muhasebe: "Muhasebe",
  depo: "Depo",
  b2b_musteri: "B2B Müşteri",
};
